import { css } from '@ni/fast-element';

export const styles = css`
    :host {
        align-self: center;
        width: 100%;
    }

    nimble-menu-button {
        width: 100%;
    }

    .value-label {
        margin-right: auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
